import type { IconSvgObject } from './types';

const AutomotiveBattery02Icon: IconSvgObject = [
  ["path", { d: "M20 5.5H4C2.89543 5.5 2 6.39543 2 7.5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V7.5C22 6.39543 21.1046 5.5 20 5.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.5 9L10 13H14L11.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.5 5V3H15V5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 5V3H5.5V5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default AutomotiveBattery02Icon;
